import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-828638ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "tovar-info"
};
const _hoisted_4 = {
  class: "container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Category = _resolveComponent("Category");
  const _component_SliderTop = _resolveComponent("SliderTop");
  const _component_CardList = _resolveComponent("CardList");
  const _component_SliderProduct = _resolveComponent("SliderProduct");
  const _component_InfoText = _resolveComponent("InfoText");
  const _directive_intersection = _resolveDirective("intersection");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Category, {
    class: "category"
  })]), _createVNode(_component_SliderTop, {
    class: "page-section"
  }), _withDirectives(_createVNode(_component_CardList, {
    "card-list-name": "Суши",
    items: $setup.sushi,
    onAddToFavorite: _cache[0] || (_cache[0] = item => this.addToFavorite(item)),
    onAddToCart: _cache[1] || (_cache[1] = item => $setup.onClickAddPlus(item)),
    onLoadMoreItems: _cache[2] || (_cache[2] = $event => !$data.allItemsLoaded_1 ? $options.loadMoreItems('sushi', 'allItemsLoaded_1') : null),
    class: "page-section"
  }, null, 8, ["items"]), [[_directive_intersection, {
    active: () => $options.load('sushi')
  }]]), _withDirectives(_createVNode(_component_CardList, {
    "card-list-name": "Роллы",
    items: $setup.rolls,
    onAddToFavorite: _cache[3] || (_cache[3] = item => this.addToFavorite(item)),
    onAddToCart: _cache[4] || (_cache[4] = item => $setup.onClickAddPlus(item)),
    onLoadMoreItems: _cache[5] || (_cache[5] = $event => !$data.allItemsLoaded_2 ? $options.loadMoreItems('rolls', 'allItemsLoaded_2') : null),
    class: "page-section"
  }, null, 8, ["items"]), [[_directive_intersection, {
    active: () => $options.load('rolls')
  }]]), _withDirectives(_createVNode(_component_CardList, {
    "card-list-name": "Сеты",
    items: $setup.sets,
    onAddToFavorite: _cache[6] || (_cache[6] = item => this.addToFavorite(item)),
    onAddToCart: _cache[7] || (_cache[7] = item => $setup.onClickAddPlus(item)),
    onLoadMoreItems: _cache[8] || (_cache[8] = $event => !$data.allItemsLoaded_3 ? $options.loadMoreItems('sets', 'allItemsLoaded_3') : null),
    class: "page-section"
  }, null, 8, ["items"]), [[_directive_intersection, {
    active: () => $options.load('sets')
  }]]), _createVNode(_component_SliderProduct, {
    slides: $setup.slides,
    class: "page-section",
    onSliderAddCart: _cache[9] || (_cache[9] = item => $options.sliderAddCart(item))
  }, null, 8, ["slides"]), _withDirectives(_createVNode(_component_CardList, {
    "card-list-name": "Закуски",
    items: $setup.snacks,
    onAddToFavorite: _cache[10] || (_cache[10] = item => this.addToFavorite(item)),
    onAddToCart: _cache[11] || (_cache[11] = item => $setup.onClickAddPlus(item)),
    onLoadMoreItems: _cache[12] || (_cache[12] = $event => !$data.allItemsLoaded_4 ? $options.loadMoreItems('snacks', 'allItemsLoaded_4') : null),
    class: "page-section"
  }, null, 8, ["items"]), [[_directive_intersection, {
    active: () => $options.load('snacks')
  }]]), _withDirectives(_createVNode(_component_CardList, {
    "card-list-name": "Напитки",
    items: $setup.drinks,
    onAddToFavorite: _cache[13] || (_cache[13] = item => this.addToFavorite(item)),
    onAddToCart: _cache[14] || (_cache[14] = item => $setup.onClickAddPlus(item)),
    onLoadMoreItems: _cache[15] || (_cache[15] = $event => !$data.allItemsLoaded_5 ? $options.loadMoreItems('drinks', 'allItemsLoaded_5') : null),
    class: "page-section"
  }, null, 8, ["items"]), [[_directive_intersection, {
    active: () => $options.load('drinks')
  }]])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_InfoText, {
    class: "tovar-info"
  })])])]);
}